<template>
  <div id="services">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style>
#services{
  height: 100%;
}
</style>